var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"copy material-icons",attrs:{"uk-tooltip":_vm.tooltip},on:{"click":_vm.copy}},[_vm._v("\n    content_copy\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }